<template>
  <div>
    <validation-observer v-slot="{}">
      <v-simple-table :height="heightTable" class="table-layout pa-5">
        <template v-slot:default>
          <thead>
            <tr class="sticky-tr">
              <th>Module</th>
              <th v-for="item in storeTypeList" style="width: 11%">
                {{item}}
              </th>
              <th>Không giữ contact</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item) in holdContactSettings">
              <tr
                :key="item.id"
              >
                <th>{{ _.get(item, 'name') }}</th>
                <template v-for="storeType in storeTypeList">
                  <td
                      style="width: 11%"
                      @dblclick="enableShowEdit(item.keepDate[storeType])"
                      v-if="item.keepDate[storeType] && item.keepDate[storeType].date !== ('' && null) && !item.keepDate[storeType]['isEdit']">
                    {{ item.keepDate[storeType].date }}
                  </td>
                  <td v-else>
                    <validation-provider
                        v-slot="{ errors }"
                        :rules="{ numeric: true, regex: /^[0-9]*$/, min_value: 0 }"
                        name="Số ngày giữ contact"
                        class="d-flex flex-wrap"
                        :customMessages="{ numeric: 'Vui lòng nhập số 0 hoặc nguyên dương' }"
                    >
                      <v-text-field
                          outlined
                          v-model="item.keepDate[storeType].date"
                          color="#7367F0"
                          :error-messages="errors"
                          @keyup.enter="updateKeepDateContact(item, item.keepDate[storeType], errors)"
                          label="Nhập số ngày"
                          :readonly="!checkAuthorization('keep-contact-setting_update')"
                          @click="showWarningPermission"
                      />
                    </validation-provider>
                  </td>
                </template>
                <td style="width: 20%">
                  <div class="" style="display: flex">
                    <v-autocomplete
                        :hint="'Click icon để lưu'"
                        v-model="item.notKeepContact"
                        :items="selectContactStatusList(item)"
                        item-text="name"
                        item-value="id"
                        label="Mối quan hệ"
                        placeholder="Mối quan hệ"
                        multiple
                        clearable
                        persistent-hint
                        :readonly="!checkAuthorization('keep-contact-setting_update')"
                    >
                    </v-autocomplete>
                    <v-icon
                        v-if="checkAuthorization('keep-contact-setting_update')"
                        color="success"
                        @click="updateStatusNotKeepContact(item)"
                    > mdi-check-outline</v-icon>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </validation-observer>
  </div>
</template>
<script>
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  const HoldContactSettingRepository = RepositoryFactory.get('hold_contact_setting')
  export default {
    props: {
      filterForm: {
        type: Object,
        default: () => {},
      },
      holdContactSettings: {
        type: Array,
        default: () => [],
      },
      storeTypeList: {
        default: () => ([]),
      },
      contactStatusList: {
        default: () => ([]),
      }
    },
    data () {
      return {
        selectedUser: {},
        modalAlert: false,
        errorMessage: ''
      }
    },
    computed: {
      heightTable() {
        return (window.innerHeight - 192);
      }
    },
    methods: {
      async updateKeepDateContact(fullItem, item, errors) {
        if (errors && errors.length) {
          return
        }
        let response
        const body = {
          storeType: item.storeType,
          keepDate: +item.date,
          store: fullItem.store,
          typeId: fullItem.typeId,
          schoolLevelId: fullItem.schoolLevelId,
          notKeepContact: fullItem.notKeepContact.join(',')
        }
        if (item.id) {
          this.appLoadingData(true)
          response = await HoldContactSettingRepository.update(item.id, body)
          this.appLoadingData(false)
        } else {
          this.appLoadingData(true)
          response = await HoldContactSettingRepository.create(body)
          this.appLoadingData(false)
        }
        if (response.success) {
          this.$swal({
            title: 'Cập nhật thành công !',
            confirmButtonText: 'Đồng ý',
            timer: 1000
          });
          Bus.$emit('hold-contact-setting-filter')
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi!',
            text: _.get(response, 'message', '')
          });
        }
      },
      async enableShowEdit (item) {
        if (!this.checkAuthorization('keep-contact-setting_update')) {
          return
        }
        item.isEdit = true
      },
      async updateStatusNotKeepContact(item) {
        const body = {
          notKeepContact: item.notKeepContact.join(','),
          typeId: item.typeId,
          schoolLevelId: item.schoolLevelId,
          store: item.store
        }
        this.appLoadingData(true)
        const response = await HoldContactSettingRepository.updateNotKeepContact(body)
        this.appLoadingData(false)
        if (response.success) {
          this.$swal({
            title: 'Cập nhật thành công !',
            confirmButtonText: 'Đồng ý',
            timer: 1000
          });
          Bus.$emit('hold-contact-setting-filter')
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi!',
            text: _.get(response, 'message', '')
          });
        }
      },
      selectContactStatusList (item) {
        return this.contactStatusList.filter(e => e.typeId == item.typeId && e.schoolLevelId == item.schoolLevelId)
      },
      showWarningPermission () {
        if (!this.checkAuthorization('keep-contact-setting_update')) {
          this.$swal({
            type: 'error',
            title: 'Cảnh báo!',
            text: "Bạn không có quyền cập nhật. Vui lòng liên hệ admin!"
          });
        }
      }
    },
  }
</script>

<style scoped>
.table-layout {
  text-align: center;
}
.table-layout th {
  text-align: center !important;
  min-width: 130px;
  font-size: 14px;
  font-weight: 500 !important;
  position: relative;
}
.table-layout th.th-id {
  width: 50px;
}

.table-layout tbody tr {
  height: 80px;
}
.table-layout tbody tr:hover {
  background: rgba(0, 0, 0, 0.11) !important;
}
/deep/ .v-data-table td, .v-data-table th {
  border: thin solid rgba(0, 0, 0, 0.12);
}
.sticky-tr {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #d5d5d5;
}
</style>
